import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";
import { useAuth } from "@/contexts/AuthContext";
import { UserCog, Eye } from "lucide-react";
import { toast } from "sonner";

export default function SuperAdminUsers() {
  const { impersonate } = useAuth();
  const [users, setUsers] = useState([]);
  const [filterRole, setFilterRole] = useState("");

  useEffect(() => {
    const q = filterRole ? `?role=${filterRole}` : "";
    api.get(`/superadmin/users${q}`).then((r) => setUsers(r.data));
  }, [filterRole]);

  const handleImpersonate = async (u) => {
    const res = await impersonate(u.id);
    if (res.success) {
      toast.success(`Ora impersoni ${u.email}`);
      const role = res.data.role;
      if (role === "casa_madre") window.location.href = "/casa-madre";
      else if (role === "rivenditore") window.location.href = "/rivenditore";
      else if (role === "customer") window.location.href = "/account";
    } else {
      toast.error(res.error);
    }
  };

  return (
    <AdminLayout>
      <div className="p-8 lg:p-10" data-testid="sa-users-page">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="overline text-brand mb-2">SuperAdmin</div>
            <h1 className="font-heading font-bold text-4xl tracking-tight">Utenti & Impersonation</h1>
            <p className="text-muted-foreground mt-2 text-sm">Entra in qualunque account come "admin fantasma": nessun prompt, banner attivo per tutta la sessione.</p>
          </div>
          <select value={filterRole} onChange={(e) => setFilterRole(e.target.value)} data-testid="users-filter-role"
            className="h-10 px-3 rounded-sm border border-border text-sm">
            <option value="">Tutti i ruoli</option>
            <option value="casa_madre">Casa Madre</option>
            <option value="rivenditore">Rivenditore</option>
            <option value="customer">Clienti</option>
          </select>
        </div>

        <div className="bg-white border border-border rounded-sm overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-[#FAFAFA] border-b border-border">
                <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Email</th>
                <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Nome</th>
                <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Ruolo</th>
                <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Network</th>
                <th className="px-5 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="border-b border-border last:border-0 hover:bg-accent/30" data-testid={`user-row-${u.email}`}>
                  <td className="px-5 py-3 text-sm font-medium">{u.email}</td>
                  <td className="px-5 py-3 text-sm">{u.name || u.full_name || "—"}</td>
                  <td className="px-5 py-3">
                    <span className={`px-2 py-0.5 text-xs rounded-full ${
                      u.role === "superadmin" ? "bg-brand/10 text-brand" :
                      u.role === "casa_madre" ? "bg-purple-50 text-purple-700" :
                      u.role === "rivenditore" ? "bg-blue-50 text-blue-700" :
                      "bg-gray-100 text-gray-700"
                    }`}>{u.role}</span>
                  </td>
                  <td className="px-5 py-3 text-xs font-mono text-muted-foreground">{(u.network_id || "—").slice(0, 8)}</td>
                  <td className="px-5 py-3 text-right">
                    {u.role !== "superadmin" && (
                      <button data-testid={`impersonate-${u.email}`} onClick={() => handleImpersonate(u)}
                        className="inline-flex items-center gap-1.5 text-xs px-3 h-8 rounded-sm bg-amber-500 text-amber-950 font-medium hover:bg-amber-400">
                        <UserCog className="w-3.5 h-3.5" /> Impersona
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
